import { formHelper } from '@/features/project-facade/helpers'

const { validationSchema: commonValidationSchema } = formHelper.validation.validationHelper.common

export const validationSchema = commonValidationSchema
